import {ModuleConfigProvider} from "base/provider";
import {Outlet} from "react-router-dom";

export const MapViewerModule = () => {
    return (
        <ModuleConfigProvider>
            <Outlet />
        </ModuleConfigProvider>
    );
};
